import React from 'react'
import { t, Trans } from '@lingui/macro'
import { DataTableDashboard } from '../DashboardContentTable/DataTableDashboard';
import { TableBody, TableHeader } from './tableData';
import { PopupPanelDashboard } from '../DashboardContentTable/PopupPanelDashboard';

import { DashboardContentPage } from '../DashboardContentTable';

import { typePaginationDashboardObject } from '../DashboardContentTable/PaginationDashboard/PaginationDashboard';

import { typeDataTicketsRowActions } from './index';
import { FiltersDashboard } from '../DashboardContentTable/FiltersDashboard';
import { InputSearch } from '../../../UI/InputSearch/InputSearch';

import { DTicketsManagementFilters } from 'components/containers/dashboard/dataTickets/filters';

import { IdTicketsStateDataItem } from 'model/dashboardTickets/dTicketsReducer';

import { PopupAdd } from 'components/containers/dashboard/dataTickets/popupContents/popupAdd';
import { PopupDetails } from 'components/containers/dashboard/dataTickets/popupContents/popupDetails';
import { ConfirmDialogDashboard } from 'components/containers/dashboard/DashboardContentTable/ConfirmDialogDashboard';
import { DTicketsManagementActions } from './actions';
import { TsoInfo } from 'components/containers/dashboard/dataTickets/tsoInfo';


// Type
export type typeViewDataTickets = {
    variant?: string
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>

    openFilterBar: boolean
    setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>

    openPopupDetails: boolean
    setOpenPopupDetails: React.Dispatch<React.SetStateAction<boolean>>

    openPopupAdd: boolean
    setOpenPopupAdd: React.Dispatch<React.SetStateAction<boolean>>

    openDeleteDialog: boolean
    setOpenDeleteDialog: React.Dispatch<React.SetStateAction<boolean>>
    onDeleteConfirmHandler: () => void
    onDeleteCancelHandler: () => void

    searchValue: string
    onChangeSearchValue: (e: ( React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement> )) => void
    onEnterSearch: () => void
    onClearSearch: () => void

    rowsActions: typeDataTicketsRowActions

    currentItem: IdTicketsStateDataItem | undefined

    pagination?: typePaginationDashboardObject
    isActiveFilters: boolean
    setIsActiveFilters: React.Dispatch<React.SetStateAction<boolean>>
}
// Component
export const ViewDataTickets: React.FC<typeViewDataTickets> = (
    {
        variant,
        setSidebarOpen,
        openFilterBar, setOpenFilterBar,

        openPopupDetails, setOpenPopupDetails,
        openPopupAdd, setOpenPopupAdd,
        openDeleteDialog, setOpenDeleteDialog,
        onDeleteConfirmHandler, onDeleteCancelHandler,

        searchValue, onChangeSearchValue,
        onClearSearch, onEnterSearch,

        rowsActions,
        currentItem,
        isActiveFilters, setIsActiveFilters
    }
) => {
    return (
        <DashboardContentPage
            headerTitle={ <Trans>Support Request</Trans> }
            setSidebarOpen={ setSidebarOpen }
            actions={
                <div className={'flex flex-grow justify-end flex-wrap sm:flex-nowrap  gap-2 relative'}>
                    <TsoInfo/>
                    <DTicketsManagementActions onClickAdd={ () => setOpenPopupAdd(true) }/>
                </div>
            }
        >
            {/* Filter bar */ }
            <FiltersDashboard
                variant={ variant }
                filters={ {
                    filtersForm: <DTicketsManagementFilters setOpenFilterBar={ setOpenFilterBar }
                                                            setIsActiveFilters={ setIsActiveFilters }/>,
                    openFilterBar: openFilterBar,
                    setOpenFilterBar: setOpenFilterBar,
                } }
                searchBar={ <InputSearch
                    id="userNameSearch"
                    name="userNameSearch"
                    placeholder={ t`Search by ticket's title` }
                    value={ searchValue }
                    onChange={ onChangeSearchValue }
                    onClear={ onClearSearch }
                    onKeyEnterDown={ onEnterSearch }
                /> }
                isActiveFilters={ isActiveFilters }
            />

            {/* Table data */ }
            <DataTableDashboard
                tableHeader={ <TableHeader/> }
                tableBody={ <TableBody variant={ variant } rowsActions={ rowsActions }
                                       setOpenPopupDetails={ setOpenPopupDetails }/> }

            />

            {/* Popup Add item dialog */ }
            <PopupPanelDashboard
                title={ <Trans>Add ticket</Trans> }
                openPopup={ openPopupAdd }
                setOpenPopup={ setOpenPopupAdd }
            >
                <PopupAdd setOpenPopup={ setOpenPopupAdd }/>
            </PopupPanelDashboard>


            {/* Item Delete dialog */ }
            <ConfirmDialogDashboard
                variant={ variant }
                type="error"
                title={ <Trans>Cancel ticket</Trans> }
                message={ <Trans>Are you sure you want to cancel this ticket <b>{ currentItem?.name }</b>?</Trans> }
                primaryButton={ { title: <Trans>Yes, cancel</Trans>, action: onDeleteConfirmHandler } }
                secondaryButton={ { title: <Trans>No, don't cancel </Trans>, action: onDeleteCancelHandler } }
                openDialog={ openDeleteDialog }
                setOpenDialog={ setOpenDeleteDialog }
            />

            {/* Popup Details */ }
            <PopupPanelDashboard
                title={ <Trans>Details</Trans> }
                openPopup={ openPopupDetails }
                setOpenPopup={ setOpenPopupDetails }

            >
                <PopupDetails setOpenPopup={ setOpenPopupDetails }/>
            </PopupPanelDashboard>

        </DashboardContentPage>
    )
}
